<template>
  <advanced-marker
    :options="{
      position: geoPointToLatLng({ coordinates: cluster.center }),
      title: cluster.name,
      anchorLeft: '-50%',
      anchorTop: '-50%',
    }"
    @click="$emit('click-cluster')"
  >
    <template #content>
      <div class="d-inline-block position-relative" @mouseenter="convexHullVisible = true" @mouseleave="convexHullVisible = false">
        <img :src="clusterData.url" :width="clusterData.scaledSize.width" :height="clusterData.scaledSize.height" />
        <p class="text-white position-absolute" style="margin-top: -1px; top: 50%; left: 50%; transform: translate(-50%, -50%)">
          {{ cluster.count }}
        </p>
      </div>
    </template>
  </advanced-marker>

  <map-polygon
    v-if="convexHullVisible"
    :options="{
      paths: polygonPath,
      strokeColor: parseColorToCSS(theme.current.value.colors.secondary),
      strokeOpacity: 0.95,
      strokeWeight: 3,
      fillColor: parseColorToCSS(theme.current.value.colors.primary),
      fillOpacity: 0.7,
    }"
  />
</template>

<script setup lang="ts">
import { AdvancedMarker, Polygon as MapPolygon } from "vue3-google-map"
import { useTheme } from "vuetify"

const { $googleApiPromise } = useNuxtApp()
const loadedGoogle = (await $googleApiPromise) as typeof google

const { cluster } = defineProps<{
  cluster: GeoCluster
}>()

defineEmits<{
  (e: "click-cluster"): void
}>()

const theme = useTheme()

const polygonPath = computed(() => cluster.convexHull.map(([lng, lat]) => ({ lat, lng })))

const convexHullVisible = ref(false)

const clusterData = computed(() => {
  if (cluster.count < 8) {
    return { url: "/clusters/m1.png", scaledSize: new loadedGoogle.maps.Size(48, 48) }
  } else if (cluster.count < 16) {
    return { url: "/clusters/m2.png", scaledSize: new loadedGoogle.maps.Size(56, 56) }
  } else if (cluster.count < 32) {
    return { url: "/clusters/m3.png", scaledSize: new loadedGoogle.maps.Size(66, 66) }
  } else if (cluster.count < 64) {
    return { url: "/clusters/m4.png", scaledSize: new loadedGoogle.maps.Size(78, 78) }
  } else {
    return { url: "/clusters/m5.png", scaledSize: new loadedGoogle.maps.Size(89, 89) }
  }
})
</script>
